import { BRAND_ASSET_GROUPS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/brand_asset_groups_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['brandAssetGroupsIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
